/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import HealthVisitIcon from 'icons/HealthVisitIcon';

const messages = defineMessages({
  title: {id: 'navigation.health-visit-log'},
});

const VisitLogItem = () => (
  <RouteLinkItem
    iconBefore={HealthVisitIcon}
    route="midas/students/health/health-visit-log"
    title={messages.title}
  />
);

export default VisitLogItem;
